import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { PlatformServices } from "@/components/PlatformServices";

import { Services } from "@/components/Services";
import { HowWeWork } from "@/components/HowWeWork";
import { Testimonials } from "@/components/Testimonials";
import { CaseStudies } from "@/components/CaseStudies";
import { TechPartners } from "@/components/TechPartners";
import { CTA } from "@/components/CTA";
import { Footer } from "@/components/Footer";
import { usePageSEO, buildHreflang } from "@/hooks/usePageSEO";
import { useCmsPageSEO } from "@/hooks/useCmsPageSEO";
import { useLanguage } from "@/contexts/LanguageContext";

const Index = () => {
  const { lang } = useLanguage();
  const isAr = lang === "ar";
  const { canonical, hreflang } = buildHreflang("/");

  useCmsPageSEO({
    title: isAr
      ? "أفضل وكالة ويب وتجارة إلكترونية في الكويت | وافاي"
      : "Top Web & eCommerce Agency in Kuwait | Wavai",
    description: isAr
      ? "وافاي وكالة الكويت الموثوقة للويب والتجارة الإلكترونية، نبني متاجر Shopify وWordPress وWebflow ومنصات مدعومة بالذكاء الاصطناعي للعلامات الرائدة في الكويت ودول الخليج."
      : "Wavai is Kuwait's trusted web and eCommerce agency, building Shopify, WordPress, Webflow and AI-powered platforms for leading brands in Kuwait and the GCC.",
    keywords: "web agency Kuwait, ecommerce agency Kuwait, Shopify Kuwait, WordPress Kuwait, Webflow Kuwait, AI development Kuwait, GCC digital agency",
    canonical,
    hreflang,
    jsonLd: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          name: "Wavai",
          url: "https://www.wavai.ae",
          logo: "https://www.wavai.ae/logo-wavai.svg",
          sameAs: [],
          contactPoint: {
            "@type": "ContactPoint",
            telephone: "+96597558522",
            contactType: "sales",
            availableLanguage: ["English", "Arabic"],
          },
        },
        {
          "@type": "WebSite",
          name: "Wavai",
          url: "https://www.wavai.ae",
          inLanguage: ["en", "ar"],
        },
      ],
    },
  });

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main>
        <Hero />
        <PlatformServices />
        <Services />
        <Testimonials />
        <CaseStudies />
        <HowWeWork />
        <TechPartners />
        <CTA />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
